export default "__VITE_ASSET__69f06677__"